// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentViewItem-Value_cls1__qDofk","cls2":"PaymentViewItem-Value_cls2__1CA4T PaymentViewItem-Value_cls1__qDofk"};